export default __webpack_public_path__ + "static/media-lg-4497715b8cc16d697a7d090eb89446ee.png";